import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const SERVICES = [
  { href: "/services/web-app-development",   label: "Web & App Development" },
  { href: "/services/ui-ux-design",          label: "UI/UX Design" },
  { href: "/services/cloud-devops",          label: "Cloud & DevOps" },
  { href: "/services/vps-hosting",           label: "VPS & Hosting" },
  { href: "/services/aws-cloud-platforms",   label: "AWS & Cloud Platforms" },
  { href: "/services/server-management",     label: "Server Management" },
  { href: "/services/ai-data",               label: "AI & Data" },
  { href: "/services/cybersecurity",         label: "Cybersecurity" },
  { href: "/services/migration-maintenance", label: "Migration & Maintenance" },
];

const PRODUCTS = [
  { href: "/products/software-solutions",     label: "Software Solutions" },
  { href: "/products/infrastructure-servers", label: "Infrastructure & Servers" },
  { href: "/products/cloud-saas-product",    label: "Cloud SaaS Products" },
  { href: "/products/website-packages", label: "Website Packages" },
  { href: "/products/e-commerce-packages", label: "E-Commerce Packages" },
  { href: "/products/software-development-packages", label: "Software Development Packages" },
  { href: "/products/hosting-packages", label: "Hosting Packages" },
];

const PORTFOLIO = [
  { href: "/portfolio/website-projects", label: "Website Projects" },
  { href: "/portfolio/mobile-apps", label: "Mobile Apps" },
  { href: "/portfolio/software-solutions", label: "Software Solutions" },
];

// Chevron icon
function Chevron({ open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18" height="18"
      viewBox="0 0 24 24"
      style={{
        transition: "transform 0.3s",
        transform: open ? "rotate(180deg)" : "rotate(0deg)",
        flexShrink: 0,
      }}
    >
      <path fill="currentColor" d="M17 9.17a1 1 0 0 0-1.41 0L12 12.71L8.46 9.17a1 1 0 0 0-1.41 0a1 1 0 0 0 0 1.42l4.24 4.24a1 1 0 0 0 1.42 0L17 10.59a1 1 0 0 0 0-1.42" />
    </svg>
  );
}

export default function Header() {
  const location = useLocation();

  // Mobile drawer open state
  const [menuOpen, setMenuOpen]     = useState(false);
  // Which submenu is expanded in mobile: "services" | "products" | null
  const [openSub, setOpenSub]       = useState(null);

  const drawerRef = useRef(null);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
    setOpenSub(null);
  }, [location.pathname]);

  // Lock body scroll when drawer open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  const toggleMenu  = () => setMenuOpen(v => !v);
  const closeMenu   = () => { setMenuOpen(false); setOpenSub(null); };

  const toggleSub = (key) => setOpenSub(v => v === key ? null : key);

  const openQuote = (e) => {
    e.preventDefault();
    if (typeof window !== "undefined" && window.$) {
      window.$("#quoteModal").addClass("active");
      window.$("body").css("overflow", "hidden");
    }
  };

  return (
    <>
      <header className="main-header">
        {/* ── Top Bar ── */}
        <div className="topbar">
          <div className="container">
            <div className="d-flex flex-wrap flex-md-nowrap align-items-center justify-content-between">
              <div className="topbar-left">
                <div className="header-location header-item">
                  <i className="fas fa-map-marker-alt"></i>Dubai, United Arab Emirates
                </div>
                <div className="header-email header-item">
                  <i className="far fa-envelope"></i>
                  <a href="mailto:info@techzoneuae.com">info@techzoneuae.com</a>
                </div>
              </div>
              <div className="topbar-right">
                <div className="header-phone header-item">
                  <i className="fas fa-phone-alt"></i>
                  <span>Call Us:</span>
                  <a href="tel:+971502424117">+971 50 24 24 117</a>
                </div>
                <div className="topbar-social">
                  <a href="https://www.facebook.com/techzoneuae" target="_blank" rel="noopener noreferrer"><i className="jsocial-facebook"></i></a>
                  <a href="#"><i className="jsocial-x"></i></a>
                  <a href="#"><i className="jsocial-linkedin"></i></a>
                  <a href="https://dubai.dubizzle.com/community/web-computer-services/website-and-app-development-services/2026/6/30/professional-business-e-commerce-website-software-development---5b2c6915f9924ea4a1c51aa17a3ed0de/" target="_blank" rel="noopener noreferrer" title="Dubizzle">
                    <img src="/assets/img/social/dubizzle.png" alt="Dubizzle" style={{ width: "20px", height: "auto" }} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── Main Nav ── */}
        <div className="header-top">
          <div className="container">
            <div className="header-top-content">
              <div className="header-brand">
                <Link to="/" className="logo">
                  <img src="/assets/img/logo-original.jpeg" alt="Tech Zone FZC" style={{ height: "60px", width: "auto" }} />
                </Link>
              </div>

              <div className="nav-wrapper">
                <nav className="nav-main">
                  <ul>
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about">About Us</Link></li>

                    {/* Desktop: Services dropdown */}
                    <li className="menu-item-has-children">
                      <Link to="/#services">
                        <span>Services &amp; Packages</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                          <path fill="currentColor" d="M17 9.17a1 1 0 0 0-1.41 0L12 12.71L8.46 9.17a1 1 0 0 0-1.41 0a1 1 0 0 0 0 1.42l4.24 4.24a1 1 0 0 0 1.42 0L17 10.59a1 1 0 0 0 0-1.42" />
                        </svg>
                      </Link>
                      <div className="dropdown-box">
                        <ul>
                          {SERVICES.map(s => <li key={s.href}><Link to={s.href}><span>{s.label}</span></Link></li>)}
                        </ul>
                      </div>
                    </li>

                    {/* Desktop: Products dropdown */}
                    <li className="menu-item-has-children">
                      <Link to="/#products">
                        <span>Products</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                          <path fill="currentColor" d="M17 9.17a1 1 0 0 0-1.41 0L12 12.71L8.46 9.17a1 1 0 0 0-1.41 0a1 1 0 0 0 0 1.42l4.24 4.24a1 1 0 0 0 1.42 0L17 10.59a1 1 0 0 0 0-1.42" />
                        </svg>
                      </Link>
                      <div className="dropdown-box">
                        <ul>
                          {PRODUCTS.map(p => <li key={p.href}><Link to={p.href}><span>{p.label}</span></Link></li>)}
                        </ul>
                      </div>
                    </li>

                    <li className="menu-item-has-children">
                      <Link to="/#portfolio">
                        <span>Portfolio</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                          <path fill="currentColor" d="M17 9.17a1 1 0 0 0-1.41 0L12 12.71L8.46 9.17a1 1 0 0 0-1.41 0a1 1 0 0 0 0 1.42l4.24 4.24a1 1 0 0 0 1.42 0L17 10.59a1 1 0 0 0 0-1.42" />
                        </svg>
                      </Link>
                      <div className="dropdown-box">
                        <ul>
                          {PORTFOLIO.map(p => <li key={p.label}><Link to={p.href}><span>{p.label}</span></Link></li>)}
                        </ul>
                      </div>
                    </li>
                    <li><Link to="/contact">Contact</Link></li>
                  </ul>
                </nav>
              </div>

              <div className="header-top-right">
                <a className="global-btn-style btn-common primary-btn header-btn get-quote-btn" href="#" onClick={openQuote}>
                  <span></span><span>Get A Quote</span><span></span>
                </a>
                {/* Hamburger */}
                <div onClick={toggleMenu} style={{ cursor: "pointer" }}>
                  <div className={`mobile-menu-toggle-new-line ${menuOpen ? "active" : ""}`}>
                    <div className="line line1"></div>
                    <div className="line line2"></div>
                    <div className="line line3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* ── Mobile Menu ── */}
      <section className="mobile-menu-area">
        {/* Overlay */}
        <div
          className={`mobile-menu-overlay ${menuOpen ? "active" : ""}`}
          onClick={closeMenu}
          style={{ cursor: "pointer" }}
        />

        {/* Drawer */}
        <div
          ref={drawerRef}
          className={`mobile-menu-wrapper ${menuOpen ? "active" : ""}`}
        >
          {/* Header */}
          <div className="mobile-menu-header">
            <Link to="/" className="mobile-menu-logo" onClick={closeMenu}>
              <img src="/assets/img/logo-original.jpeg" alt="Tech Zone FZC" style={{ height: "45px", width: "auto" }} />
            </Link>
            <button className="mobile-menu-close" onClick={closeMenu} aria-label="Close menu">&times;</button>
          </div>

          {/* Nav */}
          <nav className="mobile-menu-nav">
            <ul>
              <li><Link to="/" onClick={closeMenu}>Home</Link></li>
              <li><Link to="/about" onClick={closeMenu}>About Us</Link></li>

              {/* ── Services accordion ── */}
              <li className={`menu-item-has-children ${openSub === "services" ? "open" : ""}`}>
                <button
                  onClick={() => toggleSub("services")}
                  style={{
                    background: "none", border: "none", cursor: "pointer",
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    width: "100%", padding: "12px 0", color: "rgba(255, 255, 255, 0.8)",
                    fontFamily: "inherit", fontSize: "15px",
                  }}
                >
                  <span>Services</span>
                  <Chevron open={openSub === "services"} />
                </button>
                <ul
                  className="sm-submenu"
                  style={{
                    maxHeight: openSub === "services" ? "600px" : "0",
                    overflow: "hidden",
                    transition: "max-height 0.35s ease",
                    paddingLeft: "12px",
                  }}
                >
                  {SERVICES.map(s => (
                    <li key={s.href}>
                      <Link to={s.href} onClick={closeMenu}>{s.label}</Link>
                    </li>
                  ))}
                </ul>
              </li>

              {/* ── Products accordion ── */}
              <li className={`menu-item-has-children ${openSub === "products" ? "open" : ""}`}>
                <button
                  onClick={() => toggleSub("products")}
                  style={{
                    background: "none", border: "none", cursor: "pointer",
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    width: "100%", padding: "12px 0", color: "rgba(255, 255, 255, 0.8)",
                    fontFamily: "inherit", fontSize: "15px",
                  }}
                >
                  <span>Products</span>
                  <Chevron open={openSub === "products"} />
                </button>
                <ul
                  className="sm-submenu"
                  style={{
                    maxHeight: openSub === "products" ? "200px" : "0",
                    overflow: "hidden",
                    transition: "max-height 0.35s ease",
                    paddingLeft: "12px",
                  }}
                >
                  {PRODUCTS.map(p => (
                    <li key={p.href}>
                      <Link to={p.href} onClick={closeMenu}>{p.label}</Link>
                    </li>
                  ))}
                </ul>
              </li>

              {/* Mobile: Portfolio dropdown */}
              <li className="menu-item-has-children">
                <button
                  type="button"
                  onClick={() => toggleSub("portfolio")}
                  style={{
                    background: "none", border: "none", cursor: "pointer",
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    width: "100%", padding: "12px 0", color: "rgba(255, 255, 255, 0.8)",
                    fontFamily: "inherit", fontSize: "15px",
                  }}
                >
                  <span>Portfolio</span>
                  <Chevron open={openSub === "portfolio"} />
                </button>
                <ul
                  className="sm-submenu"
                  style={{
                    maxHeight: openSub === "portfolio" ? "200px" : "0",
                    overflow: "hidden",
                    transition: "max-height 0.35s ease",
                    paddingLeft: "12px",
                  }}
                >
                  {PORTFOLIO.map(p => (
                    <li key={p.label}>
                      <Link to={p.href} onClick={closeMenu}>{p.label}</Link>
                    </li>
                  ))}
                </ul>
              </li>
              <li><Link to="/contact" onClick={closeMenu}>Contact</Link></li>
            </ul>
          </nav>

          <div className="mobile-menu-contact">
            <a href="tel:+971502424117" className="mobile-menu-btn">
              <i className="fas fa-phone-alt"></i> Call Us Now
            </a>
            <div className="mobile-menu-social">
              <a href="https://www.facebook.com/techzoneuae" target="_blank" rel="noopener noreferrer"><i className="jsocial-facebook"></i></a>
              <a href="#"><i className="jsocial-x"></i></a>
              <a href="#"><i className="jsocial-linkedin"></i></a>
              <a href="https://dubai.dubizzle.com/community/web-computer-services/website-and-app-development-services/2026/6/30/professional-business-e-commerce-website-software-development---5b2c6915f9924ea4a1c51aa17a3ed0de/" target="_blank" rel="noopener noreferrer" title="Dubizzle">
                <img src="/assets/img/social/dubizzle.png" alt="Dubizzle" style={{ width: "20px", height: "auto" }} />
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
